<template>
	<div
		v-if="navEnabled"
		class="feed-nav"
	>
		<div
			v-for="item in navItems"
			:key="item.label"
			class="feed-nav__item"
		>
			<a
				:href="item.href"
				class="feed-nav__item-link"
				:class="{ 'is-active': item.active }"
			>
				{{ item.label }}
			</a>
		</div>
	</div>
</template>

<script>
import laroute from '@laroute';
import { mapGetters } from 'vuex';

export default {
	name:     'FeedNavigationDesktop',
	computed: {
		...mapGetters({
			userInitialized:  'user/isInitialized',
			profile:          'user/profile',
			isMobileViewport: 'device/isMobileViewport',
		}),
		navItems() {
			const items = [];
			items.push({
				label:  this.$I18n.trans('commons.arena_profile'),
				href:   '/',
				active: window.location.pathname === '/',
			});

			if (this.$arenaConfig.followingEnabled) {
				items.push({
					label:  this.$I18n.trans('arena.feed.label'),
					href:   `${laroute.route('arena.feed')}`,
					active: window.location.pathname.startsWith('/feed'),
				});
			}

			if (this.$arenaConfig.enableMomentsFeed) {
				items.push({
					label:  this.$I18n.trans('event.multiformat_editor.title'),
					href:   `${laroute.route('arena.moments')}`,
					active: window.location.pathname.startsWith('/moments'),
				});
			}
			return items;
		},
		navEnabled() {
			return this.userInitialized && this.profile && !this.isMobileViewport && (this.$arenaConfig.followingEnabled || this.$arenaConfig.enableMomentsFeed);
		},
	},

};
</script>

<style lang="scss" scoped>
@import '@sass/variables';

.feed-nav {
	position: absolute;
	display: flex;
	align-items: center;
	justify-content: center;
	gap: $sp3;
	margin-top: -26px;
	margin-left: auto;
	margin-right: auto;
	width: 100%;

	.s-header-sponsors + & {
		margin-top: $sp4;
		position: relative;
	}
}

// .feed-nav__item {}

.feed-nav__item-link {
	@include font-size(fs-120);
	width: 162px;
	height: 52px;
	display: flex;
	align-items: center;
	justify-content: center;
	background-color: var(--color-grey-900);
	color: var(--color-grey-300);
	transition: background-color $trans-time-fast;
	border-radius: $border-radius--md;
	font-weight: 500; // stylelint-disable-line

	&.is-active,
	&:hover {
		background-color: var(--color-grey-800);
	}
}
</style>
